<template>
  <div>
    <div
      v-if="visible"
      class="card-container"
      :class="{
        'not-available': !available,
        'flush': flush,
        'compact': compact,
      }"
    >
      <svg
        class="card"
        :class="{
        'card-large': large,
        'card-medium': medium,
      }"
        width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="80" height="80" rx="8" fill="#454B54"/>
        <rect x="5" y="5" width="70" height="70" rx="5" :fill="cardColor" :fill-opacity="available ? 1 : 0.8" />
        <circle cx="40" cy="33" r="16" fill="white" fill-opacity="0.5"/>
        <rect x="17" y="53" width="46" height="4" rx="2" fill="white" fill-opacity="0.5"/>
        <rect x="23" y="59" width="34" height="4" rx="2" fill="white" fill-opacity="0.5"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20.3448C15.7133 20.3448 20.3448 15.7133 20.3448 10H59.6552C59.6552 15.7133 64.2867 20.3448 70 20.3448V59.6552C64.2867 59.6552 59.6552 64.2867 59.6552 70H20.3448C20.3448 64.2867 15.7133 59.6552 10 59.6552V20.3448Z" fill="white" fill-opacity="0.7"/>
      </svg>
      <span
        class="hotel-initial"
        :class="{
          'hotel-initial-large': large,
          'hotel-initial-medium': medium,
        }"
        :style="hotelLetterPosition"
      >
        {{ hotelLetter }}
      </span>
    </div>

    <div
      v-else
      class="card-container"
    >
      <div class="card empty-card"></div>
    </div>

  </div>
</template>

<script>
import {
  HOTEL_AMERICAN,
  HOTEL_CONTINENTAL,
  HOTEL_FESTIVAL,
  HOTEL_IMPERIAL,
  HOTEL_LUXOR,
  HOTEL_TOWER,
  HOTEL_WORLDWIDE,
  HOTELS,
} from "@/store/game/constants";

export default {
  name: 'StockCard',

  props: {
    hotelId: {
      type: String,
      required: true,
      validator: function (value) {
        return HOTELS.indexOf(value) !== -1
      }
    },

    large: {
      type: Boolean,
      default: false,
    },

    medium: {
      type: Boolean,
      default: false,
    },

    visible: {
      type: Boolean,
      default: true,
    },

    available: {
      type: Boolean,
      default: true,
    },

    flush: {
      type: Boolean,
      default: false,
    },

    compact: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    cardColor() {
      switch(this.hotelId) {
        case HOTEL_AMERICAN:
          return '#144FB7';
        case HOTEL_CONTINENTAL:
          return '#F17DB6';
        case HOTEL_FESTIVAL:
          return '#128657';
        case HOTEL_IMPERIAL:
          return '#00B5C6';
        case HOTEL_LUXOR:
          return '#BD252F';
        case HOTEL_TOWER:
          return '#F2C147';
        case HOTEL_WORLDWIDE:
          return '#99593C';
        default:
          return '#99593C';
      }
    },

    hotelLetter() {
      return this.hotelId.charAt(0);
    },

    hotelLetterPosition() {
      if (this.large) {
        switch(this.hotelId) {
          case HOTEL_AMERICAN:
            return 'top: 17px; left: 30px';
          case HOTEL_CONTINENTAL:
            return 'top: 17px; left: 31px';
          case HOTEL_FESTIVAL:
            return 'top: 17px; left: 32px';
          case HOTEL_IMPERIAL:
            return 'top: 17px; left: 35px';
          case HOTEL_LUXOR:
            return 'top: 17px; left: 32px';
          case HOTEL_TOWER:
            return 'top: 17px; left: 31px';
          case HOTEL_WORLDWIDE:
            return 'top: 20px; left: 27px; font-size: 28px';
          default:
            return 'top: 17px; left: 30px';
        }
      }

      if (this.medium) {
        switch(this.hotelId) {
          case HOTEL_AMERICAN:
            return 'top: 11px; left: 17px';
          case HOTEL_CONTINENTAL:
            return 'top: 11px; left: 18px';
          case HOTEL_FESTIVAL:
            return 'top: 11px; left: 18px';
          case HOTEL_IMPERIAL:
            return 'top: 11px; left: 20px';
          case HOTEL_LUXOR:
            return 'top: 11px; left: 18px';
          case HOTEL_TOWER:
            return 'top: 11px; left: 18px';
          case HOTEL_WORLDWIDE:
            return 'top: 11px; left: 15px';
          default:
            return 'top: 11px; left: 10px';
        }
      }

      switch(this.hotelId) {
        case HOTEL_AMERICAN:
          return 'top: 8px; left: 13px';
        case HOTEL_CONTINENTAL:
          return 'top: 8px; left: 13px';
        case HOTEL_FESTIVAL:
          return 'top: 8px; left: 14px';
        case HOTEL_IMPERIAL:
          return 'top: 7px; left: 15px';
        case HOTEL_LUXOR:
          return 'top: 8px; left: 13px';
        case HOTEL_TOWER:
          return 'top: 8px; left: 14px';
        case HOTEL_WORLDWIDE:
          return 'top: 8px; left: 11px';
        default:
          return 'top: 8px; left: 7px';
      }
    }
  }
}
</script>

<style scoped>
.card-container {
  user-select: none;
  position: relative;
  margin-right: 7px;
  color: #454B54;
}

.compact {
  margin-right: 2px;
}

.card {
  user-select: none;
  width: 35px;
  height: 35px;
}

.card-mediumn {
  width: 45px;
  height: 45px;
}

.empty-card {
  background: #b9b9b945;
  border-radius: 5px;
  box-shadow: inset 3px 3px 6px #c1c1c173;
}

.not-available {
  opacity: 0.4;
}

.card-large {
  width: 80px;
  height: 80px;
}

.hotel-initial {
  user-select: none;
  font-family: 'Rozha One', serif;
  font-size: 14px;
  position: absolute;
  z-index: 2;
}

.hotel-initial-large {
  font-size: 32px;
}

.hotel-initial-medium {
  font-size: 16px;
}

.hidden {
  visibility: hidden;
}

.flush {
  margin: 0;
}
</style>
